import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { IssueItem } from "@ServerTypes/issues/issues.schema";

const initialIssuesStatusesState: IssueItem = {};

const editIssuesSlice = createSlice({
  name: "editIssues",
  initialState: initialIssuesStatusesState,
  reducers: {
    setEditIssuesData: (_state: IssueItem, action: PayloadAction<IssueItem>) => action.payload,
  },
});

export const { setEditIssuesData } = editIssuesSlice.actions;

export const editIssues = editIssuesSlice.reducer;

export default editIssuesSlice.reducer;
